import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import {
    Vehicle,
    VehicleService,
} from '@polaris-customerweb/sharedcomponents.garage';
import { Observable, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { AppState } from 'src/app/models/app-state';
import { selectVehiclesForUser } from 'src/app/state/vehicle';
import {
    AddVehicle,
    DeleteVehicle,
    SetActiveVehicleId,
    UpdateVehicle,
} from './vehicle.actions';

@Injectable({ providedIn: 'root' })
export class WebVehicleService {
    constructor(
        private store: Store<AppState>,
        private vehicleService: VehicleService
    ) {}

    /** @deprecated */
    getVehiclesWithGeofences$(): Observable<Vehicle[]> {
        return this.store.pipe(select(selectVehiclesForUser)).pipe(
            switchMap((vehicles) => {
                const vehiclesWithGeofences: Vehicle[] = [];
                vehicles.map((v) => {
                    if (v.geofences?.length > 0) {
                        vehiclesWithGeofences.push(v);
                    }
                });
                return of(vehiclesWithGeofences);
            })
        );
    }

    /**
     * @param vehicle
     * @deprecated
     */
    addVehicle(vehicle: Vehicle): Observable<Vehicle> {
        return this.vehicleService.addVehicle$(vehicle).pipe(
            tap((updatedVehicle) => {
                this.store.dispatch(AddVehicle({ vehicle: updatedVehicle }));
            })
        );
    }

    /**
     * @param vehicleId
     * @deprecated
     */
    deleteVehicle(vehicleId: string): Observable<unknown> {
        return this.vehicleService.deleteVehicle$(vehicleId).pipe(
            tap(() => {
                this.store.dispatch(DeleteVehicle({ id: vehicleId }));
            })
        );
    }

    /**
     * @param vehicle
     * @deprecated
     */
    updateVehicle(vehicle: Vehicle): Observable<Vehicle> {
        return this.vehicleService.updateVehicle$(vehicle).pipe(
            tap((updatedVehicle) => {
                this.store.dispatch(UpdateVehicle({ vehicle: updatedVehicle }));
                this.store.dispatch(
                    SetActiveVehicleId({
                        vehicleId: vehicle.id,
                    })
                );
            })
        );
    }
}
